import { PartnerPlanningShiftResponse } from 'partner/shared/services/partner-planner-service.types';
import { DateTime } from 'luxon';
import { PartnerShiftPlanningColumnDefinition } from '../shift-planning-table.types';

export const getPartnerPlanningShiftsTableData = (data: PartnerPlanningShiftResponse[]) => {
  const result: PartnerShiftPlanningColumnDefinition[] = data.map((item) => {
    const dateTime = {
      fromDateTime: DateTime.fromISO(item.dateTime.fromDateTime),
      toDateTime: DateTime.fromISO(item.dateTime.toDateTime),
    };

    return {
      id: item.id,
      jobName: item.jobName,
      companyName: item.companyName,
      departmentName: item.departmentName,
      location: item.location,
      partners: item.partners,
      dateTime,
      state: item.state,
      action: item.id,
    };
  });
  return result;
};
